module.exports = __webpack_public_path__ + "static/gallery-4-36c7ab709134bbabd1f545778758fdec.jpg";